import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { AuthnService } from '../../../services/authn.service';
import { AboutDialogComponent } from '../../misc/about-dialog/about-dialog.component';

@Component({
    selector: 'app-admin-header',
    imports: [
        MatIconModule,
        MatToolbarModule,
        MatButtonModule,
        MatMenuModule,
        MatDividerModule,
        CommonModule,
        RouterModule
    ],
    templateUrl: './admin-header.component.html',
    styleUrl: './admin-header.component.scss'
})
export class AdminHeaderComponent {

  private readonly dialog = inject(MatDialog);

  constructor(private authnService: AuthnService) {
  }

  get signedIn() {
    return this.authnService.isAuthenticated;
  }

  get username() {
    return this.authnService.username;
  }

  get roles() {
    return this.authnService.roles;
  }

  signOut() {
    console.debug('signing out');
    this.authnService.signOut();
  }

  openAbout() {
    this.dialog.open(AboutDialogComponent, {
      width: '400px'
    });
  }
}
